export function cleanObject(object) {
    for (let [key, value] of Object.entries(object)) {
        let propType = typeof(value)
        
        if (propType === 'object' && value !== null){
            if (!Array.isArray(value)){
                cleanObject(value)
                continue
            } else {
                const nullifyArray = value.map(() => null)
                object[key] = nullifyArray
                continue
            }
        }

        object[key] = null
    }
    
    return object
}

export function cleanVariable(variable){
    const propType = typeof(variable)

    if (propType === 'object') {
        if (!Array.isArray(variable)){
            cleanObject(variable)
            return variable
        } else {
            const nullifyArray = variable.map(() => null)
            variable = nullifyArray
            return variable
        }
    }
    
    variable = null

    return variable

}